import { Navigate } from 'react-router-dom'

export const PlanDetailsPage = () => <Navigate to="/mealplan" replace />
